import { BankingProductMovementsParams } from '@repo/accounts-types'
import { createDownloadSlice } from '@repo/core'

export const {
  actions: bankingProductMovementsDownloadActions,
  reducer: bankingProductMovementsDownloadReducer,
} = createDownloadSlice<BankingProductMovementsParams>(
  '@accounts/master/list/bankingProductMovementsDownload',
)
